import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Text } from 'components/Text'
import { Stack } from 'components/Stack'
import { ProductDetail } from 'models/Product'

type FurtherDetailsProps = {
  productDetail: ProductDetail
}

export const FurtherDetails = ({ productDetail }: FurtherDetailsProps) => {
  const { t } = useTranslation()

  return (
    <Stack direction="column" gap={{ '@initial': '2', '@bp2': '3' }}>
      <Text
        as="h4"
        weight="bold"
        size={{ '@initial': 'headline', '@bp2': 'h4' }}
        color="primary-800"
      >
        {t('e-commerce:detail.title')}
      </Text>
      {productDetail.details.map((detail, index) => (
        <Text
          key={index}
          size="headline"
          color="primary-800"
          dangerouslySetInnerHTML={{ __html: detail.enUS }}
        />
      ))}
    </Stack>
  )
}

FurtherDetails.displayName = 'FurtherDetails'
